import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { AppAccessNotificationDataViewModel, AppAccessNotificationKind } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";

export type AppAccessActivityProps = {
	data: AppAccessNotificationDataViewModel;
};

export const AppAccessActivity = (props: AppAccessActivityProps): ReactElement => {
	const { data } = props;

	const { appName } = data;

	const renderContent = (): ReactElement => {
		switch (data.kind) {
			case AppAccessNotificationKind.UserAccessGranted:
				return (
					<FormattedText
						text={localize("_AppNameIsNowAvailable")}
						thingsToReplace={[
							{
								what: "{{AppName}}",
								filler: (
									<Typography
										trackingId="app-name"
										weight="bold"
									>
										{appName}
									</Typography>
								)
							}
						]}
					/>
				);

			case AppAccessNotificationKind.UserAndOwnerAccessGranted:
				return (
					<FormattedText
						text={localize("_AppNameIsNowAvailableYouHaveOwnerPermissions")}
						thingsToReplace={[
							{
								what: "{{AppName}}",
								filler: (
									<Typography
										trackingId="app-name"
										weight="bold"
									>
										{appName}
									</Typography>
								)
							}
						]}
					/>
				);
			case AppAccessNotificationKind.OwnerAccessGranted:
				return (
					<FormattedText
						text={localize("_YouNowHaveOwnerPermissions")}
						thingsToReplace={[
							{
								what: "{{AppName}}",
								filler: (
									<Typography
										trackingId="app-name"
										weight="bold"
									>
										{appName}
									</Typography>
								)
							}
						]}
					/>
				);
			default:
				throw new Error(`Unsupported app access kind ${data.kind}`);
		}
	};

	return (
		<span {...setTrackingId("title")}>
			{renderContent()}
		</span>
	);
};

AppAccessActivity.displayName = "AppAccessActivity";